export default "__VITE_ASSET__odDSg2Kf__"